import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../../services/settings.service';
import {MetodosServicio} from '../../../_helpers/interfaces/metodos-servicio';
import {Apikeys} from '../../../_models/apikeys';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApikeysService extends MetodosServicio<Apikeys> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'procesadora/apikeys', Apikeys);
  }

  restartItem(): void {
    this.setItem(new Apikeys());
  }

  getAll(filtro: string = "", cantidad?: string, pagina?: string, orden?: string, columna?: string): Observable<any> {
    cantidad = cantidad != 'undefined' ? cantidad : '10';
    return this.http.post(this.settings.URL_BASE + 'fraccionate/apikeys/list', filtro);
  }
}
